import { Phone } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { WHATSAPP_NUMBER } from "../context/CartContext";
import { copy, BUSINESS } from "../data/copy";

/**
 * Spice-level customisation note — shown on every ordering surface
 * (cart, checkout, product page, past orders).
 */
export const SpiceNote = ({ testId = "spice-custom-note", className = "" }) => {
    const { t } = useLang();
    return (
        <div
            className={`flex items-start gap-2 rounded-2xl bg-[color:var(--kp-turmeric)]/12 border border-[color:var(--kp-turmeric)]/35 px-4 py-3 ${className}`}
            data-testid={testId}
        >
            <Phone size={13} className="mt-0.5 shrink-0 text-[color:var(--kp-terracotta)]" />
            <p className="text-[12px] leading-snug text-[color:var(--kp-ink)]/80">
                {t(copy.products.spice_custom_note)}{" "}
                <a
                    href={`tel:+${WHATSAPP_NUMBER}`}
                    className="font-bold text-[color:var(--kp-terracotta)] underline decoration-dotted"
                    data-testid={`${testId}-call`}
                >
                    {BUSINESS.phone_display}
                </a>
                {" · "}
                <a
                    href={`https://wa.me/${WHATSAPP_NUMBER}`}
                    target="_blank"
                    rel="noreferrer"
                    className="font-bold text-[color:var(--kp-banana)] underline decoration-dotted"
                    data-testid={`${testId}-whatsapp`}
                >
                    {t({ en: "WhatsApp", te: "వాట్సాప్" })}
                </a>
            </p>
        </div>
    );
};
